import React from "react";

const CustomInput = ({ register, id, required, type, placeholder, min }) => {
  return (
    <input
      type={type}
      min={min}
      className="my-5 block w-full p-3 bg-white border 
          border-light rounded-xl text-sm shadow-sm placeholder-gray-400
      focus:outline-none focus:border-off-white focus:ring-0 focus:ring-grey
      disabled:bg-gray-50 disabled:text-gray-500 disabled:border-light 
      disabled:shadow-none
      invalid:border-pink-500 invalid:text-pink-600
      focus:invalid:border-pink-500 focus:invalid:ring-pink-500"
      placeholder={placeholder}
      {...register(id, { required: required })}
    />
  );
};

export default CustomInput;
